import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "ion-margin-bottom" }, "Payment Confirmation", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_loading = _resolveComponent("ion-loading")!
  const _component_booking_card = _resolveComponent("booking-card")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_base_layout = _resolveComponent("base-layout")!

  return (_openBlock(), _createBlock(_component_base_layout, null, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ion_loading, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.booking)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_booking_card, { booking: _ctx.booking }, null, 8, ["booking"]),
            _hoisted_2,
            _createVNode(_component_ion_button, {
              class: "ion-margin-top",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.claimBooking())),
              "router-link": "/bookings/my"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Confirm Payment")
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}